var map = {
	"./Amex.png": 5898,
	"./Benefit.png": 8140,
	"./Credit.png": 5713,
	"./Credit0.png": 6580,
	"./Credit1.png": 6998,
	"./Fawry.png": 3535,
	"./KNET.png": 3816,
	"./MASTER.png": 8973,
	"./MediaWorld.png": 9129,
	"./Pointcheckout.png": 8138,
	"./Tasdeed.png": 3672,
	"./VISA.png": 195,
	"./Zaincash.png": 7246,
	"./directpay.png": 7606,
	"./efawateercom.png": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8385;